import { z } from 'zod'

export const params = z.record(z.string(), z.string().or(z.number()).or(z.boolean()))
export type ParamsSchema = z.infer<typeof params>
